const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
                const elements = node.querySelectorAll('.sale_flag');
                elements.forEach(applyDiscountColor);
                if (node.classList.contains('sale_flag')) {
                    applyDiscountColor(node);
                }
            }
        });
    });
});

function applyDiscountColor(element) {
    const text = element.innerText || '';
    const match = text.match(/(\d+)%/);
    if (match) {
        const percentage = parseInt(match[1], 10);
        if (percentage >= 1 && percentage <= 15) {
            element.style.backgroundColor = '#212D81cc';
            element.style.color = 'white';
        } else if (percentage >= 16 && percentage <= 29) {
            element.style.backgroundColor = '#FCDE0Fcc';
            element.style.color = 'black';
        } else if (percentage >= 30 && percentage <= 70) {
            element.style.backgroundColor = '#1A5B18cc';
            element.style.color = 'white';
        }
    }
}
observer.observe(document.body, {
    childList: true,
    subtree: true
});
document.querySelectorAll('.sale_flag').forEach(applyDiscountColor);